import { Injectable, OnDestroy } from '@angular/core'
import { FeathersService } from '../../feathers.service'
import { Gender } from 'src/app/models/gender'
import { Observable, Subscription } from 'rxjs'
import { filter, map, shareReplay } from 'rxjs/operators'
import { CodeListService } from './CodeListService'

@Injectable({
  providedIn: 'root',
})
export class GendersService extends CodeListService<Gender> implements OnDestroy {
  recordClass = Gender
  emptyGenderAdded = false

  public static MALE_ABBR = 'M'
  public static FEMALE_ABBR = 'F'

  constructor(feathers: FeathersService) {
    super(feathers)
  }

  public getAllWithAddedEmptyGender(): Observable<Gender[]> {
    if (!this.entity$) this.initObservable()

    return this.entity$.pipe(
      map((genders) => {
        if (!this.emptyGenderAdded) {
          this.emptyGenderAdded = true
          genders.unshift(Gender.createEmptyGender())
        }
        return genders
      }),
    )
  }

  getById(id: number) {
    return this.getAll().pipe(map((genders) => genders.find((gender) => id === gender.id)))
  }

  static getByIdFromSuppliedGenders(id: number, genders: Gender[]) {
    return genders.find((gender) => id === gender.id)
  }

  static isMaleByIdFromSuppliedGenders(id: number, genders: Gender[]) {
    if (!id) return false
    return this.getByIdFromSuppliedGenders(id, genders)?.abbr === 'M'
  }
  static isFemaleByIdFromSuppliedGenders(id: number, genders: Gender[]) {
    if (!id) return false
    return this.getByIdFromSuppliedGenders(id, genders)?.abbr === 'F'
  }
}
